// Remember:
// Every file in scripts/ acts as an entry-point and gets tranformed to build/. Feel free to create as much as you want.
// Files in subdirectories will be ignored but you can require them in entry-point-files.
// Add an _ to a file and it will just be ignored(good for tests).
// Add your entry-point-files to templates/layout/yourlayout.html





// ATOMS

//=require ../../patterns/atoms/lazyload/_lazyload.js
//=require ../../patterns/atoms/animate-on-scroll/animate-on-scroll.js
//=require ../../patterns/atoms/loading-overlay/_loading-overlay.js
//=require ../../patterns/atoms/top-scroll/_top-scroll.js
//=require ../../patterns/atoms/detect-input/_detect-input.js
//=require ../../patterns/atoms/forms/_selects.js
//=require ../../patterns/atoms/icon/_icon.js



// MOLECULES

//=require ../../patterns/molecules/textrow/_textrow.js
//=require ../../patterns/molecules/hero-slider/_hero-slider.js
//=require ../../patterns/molecules/masonary/_masonary.js
//=require ../../patterns/molecules/consent-dialog/_consent-dialog-config.js
//=require ../../patterns/molecules/consent-dialog/_consent-dialog.js
//=require ../../patterns/molecules/teaser/_teaser.js
//=require ../../patterns/molecules/accordion/_accordion.js
//=require ../../patterns/molecules/slideshow/_slideshow.js
//=require ../../patterns/molecules/navigation/nav-main/_nav-main.js
//=require ../../patterns/molecules/navigation/nav-mobile/_nav-mobile.js
//=require ../../patterns/molecules/lightbox/_lightbox.js




// ORGANISMS

//=require ../../patterns/organisms/header/_header.js
//=require ../../patterns/organisms/calculator/_calculator.js
//=require ../../patterns/organisms/career-teaser/_career-teaser.js




// DEV ONLY!

// document.addEventListener('keyup', function() {console.log(document.activeElement)})

